// @owners { team: patients }

export const WEB_VIEW_WEB_MAX_HEIGHT = 300;
export const WEB_VIEW_MOBILE_MAX_HEIGHT = 350;
export const WEB_VIEW_INITIAL_HEIGHT = 100;

export const REVIEW_TERMS_FOOTNOTE =
  'Please review all the terms and conditions before confirming you meet the requirements below.';
